import React from "react"
import MultiCarousel from "react-multi-carousel"
import "react-multi-carousel/lib/styles.css"
import NonStretchedImage from "../Image/non-stretched-image"
import PropTypes from "prop-types"
import {
  addressCarousel,
  addressCarouselItem,
  addressImg,
  addressImgSolo,
} from "./carousel.module.scss"

//-----------------------Parent Component---------------------------//

const Carousel = ({ address }) => {
  if (address.relationships.field_image_adresse.length === 1) {
    return (
      <div className={addressImgSolo}>
        <NonStretchedImage
          {...address.relationships.field_image_adresse[0].localFile}
        />
      </div>
    )
  }
  return <MyCarousel address={address} />
}

//-----------------------Parent Component---------------------------//

//-----------------------Child Component---------------------------//

const MyCarousel = ({ address }) => {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 600 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 600, min: 0 },
      items: 1,
    },
  }
  return (
    <div className={addressCarousel}>
      <MultiCarousel
        className={addressCarouselItem}
        transitionDuration={500}
        autoPlay={true}
        responsive={responsive}
        autoPlaySpeed={5000}
        infinite={true}
        arrows={true}
        dots={true}
      >
        {address.relationships.field_image_adresse.map((img) => {
          const srcImg = img.localFile.SlugifiedPublicUrl
          const altImg = img.filename
          return (
            <div key={address.drupal_id} className={addressImg}>
              <img alt={altImg} src={srcImg} />
            </div>
          )
        })}
      </MultiCarousel>
    </div>
  )
}

//-----------------------Child Component---------------------------//

//-----------------------Prop-Types---------------------------//

Carousel.propTypes = {
  address: PropTypes.object.isRequired,
}
MyCarousel.propTypes = {
  address: PropTypes.object.isRequired,
}
//-----------------------Prop-Types---------------------------//

export default Carousel
